import React, { PureComponent } from "react";
import { changeLocation } from "api/Location";

import Logo from "../../containers/assets/LandingPageLogo3.png";
import { getRequest, postRequest, batchRequest, patchRequest } from "../../api/ApiService";
import Auth from "../../routes/Auth";
import EventEmitter from "../../services/event-emitter";
import Teams from "../../api/Teams";
import Loader from "react-loaders";

class PaymentsWidget extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isSuccess: props.isSuccess,
      isCancel: props.isCancel,
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    const {
      isSuccess,
      isCancel,
    } = this.state;

    if (isSuccess) {
      this.continue();
    } else if (isCancel) {
      this.logout();
    } else if (Auth.isPaid() === true) {
      this.detectIsPaid();
    } else {
      this.checkout();
    }
  }

  checkout = () => {
    postRequest(`${process.env.REACT_APP_API_URL}v2/payments/create-checkout-session/`)
      .send('quantity=1')
      .then(res => {
        window.location.href = res.body;
      })
      .catch(err => {
        console.log(err);
      });
  }

  continue = () => {
    getRequest(`${process.env.REACT_APP_API_URL}v2/games/coursemembers/`)
      .then(res => {
        const courseMember = res.body.results.find(i => Number(i.user.id) === Number(Auth.getUserId()));

        if (courseMember) {
          patchRequest(`${process.env.REACT_APP_API_URL}v2/games/coursemembers/${courseMember.id}/`)
            .send({
              registered_at: new Date(),
            })
            .then(res => {
              this.detectIsPaid();
            })
            .catch(err => {
              console.log(err);
              this.detectIsPaid();
            });
        } else {
          console.log(`Cannot find course member for user = ${Auth.getUserId()}`);
          this.detectIsPaid();
        }
      })
      .catch(err => {
        console.log(err);
        this.detectIsPaid();
      });
  }

  detectIsPaid = () => {
    getRequest(Auth.getUserDataRequest())
      .then(res => {
        Auth.setUserData(res.body);

        if (Auth.isPaid() === true) {
          this.authorizeUser();
        } else {
          setTimeout(() => {
            this.detectIsPaid();
          }, 1000);
        }
      })
      .catch(err => {});
  };

  authorizeUser = () => {
    if (Auth.getRole() === "" || !Auth.getTeamId()) {
      Teams.setEmptyData();
      this.eventemitter.trigger("reload-data");
      changeLocation("/join");
    } else {
      this.loadTeamRoles(() => {
        this.eventemitter.trigger("reload-data");
        changeLocation(`/start`);
      });
    }
  };

  loadTeamRoles = callback => {
    const joinRequest = batchRequest([
      ...Teams.requests(),
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/`
    ]);

    joinRequest
      .then(res => {
        const teams_data = [
          {
            status: res[0].statusCode,
            data: res[0].body
          },
          {
            status: res[1].statusCode,
            data: res[1].body
          }
        ];
        const teams_status = Teams.setData(teams_data);
        if (teams_status === "Error") {
          throw teams_status;
        }

        Auth.setPlayerRoles(res[2].body.results);

        if (callback) {
          callback();
        }
      })
      .catch(err => {
        console.error(err);
      });
  };

  logout = () => {
    if (Auth.isUserAuthenticated()) {
      Auth.deauthenticateUser();
    }

    changeLocation("/login");
  };

  render() {
    const { mode } = this.props;
    const containerClassName =
      mode === "page"
        ? "container promocode-container"
        : "promocode-container without-max-width";

    return (
      <div className={containerClassName}>
        <div className="row">
          <div className="col-md-12">
            <div className="promocode-header">
              <img src={Logo} alt="Logo" className="promocode-logo" />
              <span className="payment-header-caption">
                Market Games
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="text-center loader-inline" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
              <Loader type="ball-scale-ripple" active={true} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentsWidget;



// WEBPACK FOOTER //
// ./src/components/payments/index.js